const Error = () => {
    return (
        <section className="error">
            <h2>404</h2>
            <p>sorry this page is still under construction</p>
        </section>
    )
}
export default Error;